import { createContext } from "preact";
import { ReferrerServiceInterface } from '@authentic/loyalty-pwa/interfaces/refferer.service.interface';

export const ReferrerServiceContext = createContext<ReferrerServiceInterface | null>(null)
